import React from 'react';
import { useInventory } from '../context/InventoryContext';
import { Home, Trash2, Plus } from 'lucide-react';

export default function Warehouses() {
  const { warehouses, setWarehouses } = useInventory();

  const addWarehouse = () => {
    const name = prompt("اسم المستودع الجديد:");
    if (!name) return;
    const newW = { id: 'w' + Date.now(), name };
    setWarehouses([...warehouses, newW]);
  };

  const deleteWarehouse = (id) => {
    if(id === 'w1' || id === 'w2') return alert("لا يمكن حذف المستودعات الأساسية");
    if(window.confirm("حذف المستودع")) {
      setWarehouses(warehouses.filter(w => w.id !== id));
    }
  };

  return (
    <div className="space-y-6 max-w-2xl mx-auto">
      <div className="flex justify-between items-center text-right">
        <h2 className="text-2xl font-bold">المستودعات والمخازن</h2>
        <button onClick={addWarehouse} className="bg-slate-800 text-white px-4 py-2 rounded-lg flex items-center gap-2 font-bold">
          <Plus size={20} /> إضافة مخزن
        </button>
      </div>

      <div className="space-y-3">
        {warehouses.map(w => (
          <div key={w.id} className="bg-white p-4 rounded-xl border flex justify-between items-center shadow-sm">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-slate-100 rounded-full text-slate-600"><Home size={20} /></div>
              <div>
                <div className="font-bold">{w.name}</div>
                <div className="text-xs text-slate-400 font-mono">ID: {w.id}</div>
              </div>
            </div>
            <button onClick={() => deleteWarehouse(w.id)} className="text-slate-300 hover:text-red-500 transition-colors">
              <Trash2 size={20} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
